module.exports = __webpack_public_path__ + "static/media/snow-blowing.bec34af8.svg";